<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        	<el-breadcrumb-item>财务管理</el-breadcrumb-item>
            <el-breadcrumb-item>账单汇总</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form :inline="true" :model="item" class="search">
            <el-form-item label="订单号">
                <el-input v-model="item.phone" placeholder="请输入订单号"
                          size="small"></el-input>
            </el-form-item>
            <el-form-item label="所属店铺">
                <el-select v-model="item.shop" clearable placeholder="请先选择所属商家" size="small">
                    <el-option
                            v-for="item in optionsShop"
                            :key="item.value"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="item.shop" placeholder="状态" size="small">
                    <el-option label="待审核" value=""></el-option>
                    <el-option label="待审核" value=""></el-option>
                    <el-option label="已完成" value=""></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间">
                <el-date-picker
                        size="small"
                        style="margin-left: 10px"
                        v-model="item.times"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" size="medium">查询</el-button>
            </el-form-item>
        </el-form>
        <el-row class="sunFinance">
            <el-col :span="6">订单总数：<span>1</span> 单， 金额：<span>33248</span> 元</el-col>
            <el-col :span="6">已完成：<span>2</span> 单， 金额：<span>33248</span> 元</el-col>
            <el-col :span="6">未完成：<span>3</span> 单， 金额：<span>33248</span> 元</el-col>
            <el-col :span="6">退货：<span>4</span> 单， 金额：<span>33248</span> 元</el-col>
        </el-row>
        <el-row class="sunFinance">
            <el-col :span="24">合计：<span>10</span> 单， 金额：<span>33248</span> 元</el-col>
        </el-row>


        <!--		数据是list 通过list展示-->
        <el-table :data="list" border>
            <el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>
            <el-table-column prop="indent" label="订单号"></el-table-column>
            <el-table-column prop="name" label="商品名称"></el-table-column>
            <el-table-column prop="money" label="单价"></el-table-column>
            <el-table-column prop="num" label="数量"></el-table-column>
            <el-table-column prop="fee" label="金额"></el-table-column>
            <el-table-column prop="shop" label="所属地安排"></el-table-column>
            <el-table-column prop="status" label="状态"></el-table-column>
            <el-table-column prop="date" label="创建日期"></el-table-column>
        </el-table>
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
                       :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
    export default {
        name: 'index',
        data() {
            return {
                list: [{
                    id: 1,
                    number: '1',
                    indent: '11',
                    name: '商品名称1',
                    money:'1',
                    num: 1000,
                    fee: "100.00",
                    status: '待审核',
                    date: "2021-07-01 17:24:28"
                }, {
                    id: 2,
                    number: '2',
                    indent: '22',
                    name: '商品名称2',
                    money:'2',
                    num: 1000,
                    fee: "10110.00",
                    status: '待审核',
                    date: "2021-07-01 17:24:28"
                }, {
                    id: 3,
                    number: '3',
                    indent: '33',
                    money:'3',
                    name: '商品名称3',
                    num: 101100,
                    fee: "10004110.00",
                    status: '待结算',
                    date: "2021-07-01 17:24:28"
                }],
                isLoad: false,
                pageSize: 20,
                total: 0,
                page: 1,
                // 查询
                item: {}
            }
        },
        created() {
			this.item = {
				page: this.page,
				limit: this.pageSize
			}
            // this.loadList()
        },
        methods: {
            loadList() {
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.post('/store/list', this.item)
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 获取数据
                        this.list = res.data.records
                        // 页数 page
                        this.total = res.data.total
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            // 跳转到edit添加
            add() {
                return
                this.$router.push({path: '/Member/MemberLevelEdit.html'});
            },
            audit(id) {
                this.$router.push({
                    path: '/Finance/audioStatement.html',
                    query: {
                        id: id
                    }
                });
            },
            // 传一个ID跳转到edit页面，进行编辑
            end(id) {
                this.$router.push({
                    path: '/Finance/endStatement.html',
                    query: {
                        id: id
                    }
                });
            },
            sizeReload(val) {
                this.item.pageSize = val
              //   this.loadList()
            },
            pageReload(val) {
                this.item.page = val
              //   this.loadList()
            },
            // 搜索查询
            submit() {
                return
                this.item.page = 1
              //   this.loadList()
            },
            // 导出
            excelOut() {
                return;
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.get('/Member/excelOut', {
                    params: {
                        nickname: this.item.nickname,
                        title: this.item.title
                    }
                })
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 导出
                        window.open(res.url)
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            }
        },

    }
</script>
<style scoped>
    .sunFinance {
        margin-bottom: 20px;
        text-align: center;
    }

    .sunFinance .el-col {
        height: 50px;
        line-height: 50px;
        font-size: 16px;

        border: 1px solid #EBEEF5;
        border-right: none;
    }

    .sunFinance .el-col:last-child {
        border-right: 1px solid #EBEEF5;
    }

    .sunFinance span {
        font-size: 20px;
        color: red;
    }
</style>